import { useLocation, useSearchParams } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { useAllVisibleClips } from '@/hooks/useAllVisibleClips';

export const useSetFirstClipAsDefault = ({ enabled }: { enabled: boolean }) => {
  const { allVisibleClips } = useAllVisibleClips();

  const [searchParams, setSearchParams] = useSearchParams();

  const clipId = useMemo(() => {
    return searchParams.get('activeClipId');
  }, [searchParams]);

  const { pathname } = useLocation();

  useEffect(() => {
    if (allVisibleClips.length === 0 || !enabled) {
      return;
    }
    if (!clipId && pathname.endsWith('/clips')) {
      setSearchParams({ activeClipId: allVisibleClips[0].id });
    }
  }, [pathname, allVisibleClips, searchParams, clipId, enabled, setSearchParams]);
};
